import { Injectable } from '@angular/core';

@Injectable()
export class GlobalconfigService {

  baseApiUrl: string = 'https://uapi.fof-fuso.com/logbaseiam/';
 baseApiUrlPfep: string = 'https://uapi.fof-fuso.com/pfepiam/';
 
  constructor() {
   }

}
